import React, { useMemo } from 'react';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import { getDeviceKindDependsOnViewPort } from '@bit/gerenciatd.utils.common';
import { DEVICES } from '@bit/gerenciatd.utils.constants';
import ModalAtencionEmp from '@bit/gerenciatd.unifiedcomponents.modal-atencion-emp';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import PropTypes from 'prop-types';
import { SEGMENT } from './utils.js';
import './Flotante.scss';

export const C2C_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  CORAL: 'coral',
  AMBAR: 'ambar',
  GrEY2: 'grey2',
};

export const COMPONENT_NAME = 'ContactCircle';

const Flotante = (props) => {
  const {
    Modal,
    flotanteProps,
    SvgIconLoader,
    modalAtencionConfig,
    visible,
  } = props;
  let { taggingInfo } = props;

  const {
    iconId,
    iconSize,
    iconSegment,
    iconKind,
    iconColor,
    labelColor,
    labelText,
    labelSize,
    backgroundColor,
    desktopContainerTop,
    mobileContainerTop,
    title,
    option,
  } = flotanteProps;

  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: flotanteProps.campaign || 'all',
      componentName: COMPONENT_NAME,
      componentProduct: '',
    };
  }

  const containerRootClass = 'clickToCall';

  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    });
  };

  const handleNewModal = (item) => {
    setUpModalProps();
    Modal.setContent(
      <ModalAtencionEmp
        Modal={Modal}
        taggingInfo={{
          ...taggingInfo,
        }}
        SvgIconLoader={SvgIconLoader}
        campaign={item.campaign}
        product={`Interes ${item.product}`}
        tabsOptions={{
          ...modalAtencionConfig,
          tabOptionPreChecked: item.option,
        }}
      />,
    );
    return Modal.show();
  };

  const generateClassNameWithColor = (
    className,
    color,
    defaultColor = C2C_COLORS.WHITE,
  ) => {
    let classColor = defaultColor;
    const colorExist = Object.values(C2C_COLORS).find(c => c === color);

    if (colorExist) {
      classColor = colorExist;
    }

    return `${className} ${className}_${classColor}`;
  };

  const getTopNumberByDevice = (desktopTop, mobileTop) => {
    const device = getDeviceKindDependsOnViewPort();
    if (device === DEVICES.PC) {
      if (Number.isInteger(desktopTop)) {
        return desktopTop;
      }
    } else if (Number.isInteger(mobileTop)) {
      return mobileTop;
    }

    return 0;
  };

  const wrapper = {
    top: `${getTopNumberByDevice(desktopContainerTop, mobileContainerTop)}px`,
  };

  const componentContainerClass = useMemo(
    () => generateClassNameWithColor(
      containerRootClass,
      backgroundColor,
      C2C_COLORS.CORAL,
    ),
    [backgroundColor],
  );

  const renderLinkWithModal = () => {
    return (
      <span className="transparent-background">
        <SvgIconLoader
          segment={iconSegment}
          id={iconId}
          kind={iconKind}
          size={iconSize}
          color={iconColor}
        />
        <TextInfo
          kind="span"
          size="caption01"
          text={labelText}
          fontType="font-regular"
          color={labelColor}
          segment={iconSegment}
          className="flotante-txt"
        />
        <TextInfo />
        <SvgIconLoader
          segment={iconSegment}
          id="CheuronRight"
          kind="M"
          size={16}
          color={iconColor}
          className="flotante-cheuron"
        />
      </span>
    );
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={componentContainerClass} style={wrapper}>
      {renderLinkWithModal()}
      <CustomLink
        isBlockElement
        onClick={() => {
          handleNewModal(flotanteProps);
        }}
        accInfo={{ title: title || 'Te asesoramos' }}
        taggingInfo={{
          ...taggingInfo,
          componentContent: `${option}-flotante`,
          componentVariation: flotanteProps.campaign || 'all',
        }}
      />
    </div>
  );
};

Flotante.defaultProps = {
  visible: true,
  segment: SEGMENT.EMP,
  flotanteProps: {
    iconId: 'Fijo',
    iconKind: 'M',
    iconSize: 31,
    iconColor: 'grey6',
    iconSegment: 'emp',
    desktopContainerTop: 418,
    mobileContainerTop: 256,
    backgroundColor: 'ambar',
    title: 'Te asesoramos',
  },
};

Flotante.propTypes = {
  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: PropTypes.oneOf([SEGMENT.GP, SEGMENT.EMP]),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: PropTypes.bool,
  flotanteProps: PropTypes.shape({
    iconId: PropTypes.string.isRequired,
    iconKind: PropTypes.string.isRequired,
    iconSize: PropTypes.number.isRequired,
    iconColor: PropTypes.string.isRequired,
    iconSegment: PropTypes.oneOf(SEGMENT).isRequired,
    desktopContainerTop: PropTypes.number.isRequired,
    mobileContainerTop: PropTypes.number.isRequired,
    iconContainerColor: PropTypes.oneOf(C2C_COLORS).isRequired,
    backgroundColor: PropTypes.oneOf(C2C_COLORS).isRequired,
    title: PropTypes.string.isRequired,
  }),
  Modal: PropTypes.func.isRequired,
  // Para cambiarle el producto que enviara el formulario
  fixedProduct: PropTypes.string,
  // Para setearle una campaña al formulario distinta de la que pueda dar SCX
  fixedCampaign: PropTypes.string,
};

export default Flotante;
